/**
 * Frontend runtime configuration. All values come from Vite env vars
 * (prefixed VITE_) so they can be set per-environment at build time.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export const TOKEN_STORAGE_KEY = 'token';
export const USER_STORAGE_KEY = 'user';
